// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
//require("jquery-autocomplete")
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";

Rails.start()
Turbolinks.start()
ActiveStorage.start()
global.Turbolinks = Turbolinks;

document.addEventListener('click', function (event) {
  var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
  if (!link) {
    return;
  }

  var href = link.getAttribute('href') || '';
  if (href.charAt(0) === '#' || link.target === '_blank' || link.hasAttribute('download')) {
    return;
  }

  var url;
  try {
    url = new URL(href, window.location.href);
  } catch (error) {
    return;
  }

  if (url.origin !== window.location.origin) {
    return;
  }

  window.__kairosPreserveScrollForNextVisit = link.dataset.scrollTop === 'false' || Boolean(url.hash);
  window.setTimeout(function () {
    window.__kairosPreserveScrollForNextVisit = false;
  }, 0);
}, true);

document.addEventListener('turbolinks:before-visit', function (event) {
  var url;
  try {
    url = new URL(event.data.url, window.location.href);
  } catch (error) {
    return;
  }

  if (window.__kairosPreserveScrollForNextVisit || url.hash) {
    window.__kairosPreserveScrollForNextVisit = false;
    return;
  }

  window.__kairosScrollTopAfterVisit = true;
});

function resetKairosScrollAfterVisit() {
  if (!window.__kairosScrollTopAfterVisit) {
    return;
  }

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

document.addEventListener('turbolinks:render', resetKairosScrollAfterVisit);

document.addEventListener('turbolinks:load', function () {
  if (!window.__kairosScrollTopAfterVisit) {
    return;
  }

  resetKairosScrollAfterVisit();
  window.requestAnimationFrame(function () {
    resetKairosScrollAfterVisit();
    window.requestAnimationFrame(function () {
      resetKairosScrollAfterVisit();
      window.__kairosScrollTopAfterVisit = false;
    });
  });
});

require("channels")
require ("jquery-ui/ui/widgets/autocomplete")



 
 

// jquery
import $ from 'jquery';
global.$ = $;
global.jQuery = $;
import 'stylesheets/application'
require("./custom/places")
require("./custom/newsletter")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
